<template>
    <div class="account">
        <a-page-header
        style="border: 1px solid rgb(235, 237, 240);background:#fff;padding:16px 32px"
        :breadcrumb="{ props: { routes } }"
        />
        <div class="account-deatil bwlist" style="background:#fff;">
            <a-card>
                <div>
                    <div class="search">
                        <a-button type="primary" style="margin-left:14px" @click="addmodal">添加IP黑名单</a-button>
                    </div>
                    <a-table
                        :columns="columns"
                        :pagination="pagination"
                        :loading="loading"
                        @change="handleTableChange"
                        :data-source="data"
                    >
                        <span slot="action" slot-scope="text, record">
                            <a-button type="primary" :size="size"  @click="editmodal(index,$event)" :id="record.id"><a-icon type="edit" />编辑</a-button>
                            <a-button type="danger" :size="size" @click="deletip(index,$event)" :id="record.id"><a-icon type="delete" />删除</a-button>
                        </span>
                    </a-table>

                </div>
            </a-card>
        </div>

        <!-- 添加 -->
        <a-modal
            class="pwdmodal"
            title="添加IP黑名单"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="addrolemodal"
            :confirm-loading="confirmLoading"
            @ok="addip"
            @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">IP地址：</label>
                </a-col>
                <a-col :span="16">
                   <a-textarea :rows="6" v-model="ipaddress" placeholder="请输入IP地址(一行一个，回车换行)"></a-textarea>
                </a-col>
            </a-row>
        </a-modal>

        <!-- 编辑 -->
        <a-modal
            class="pwdmodal"
            title="编辑IP黑名单"
            cancelText="取消"
            okText="确定"
            width="600px"
            :visible="editrolemodal"
            :confirm-loading="confirmLoading"
            @ok="editip"
            @cancel="handleCancel"
        >
            <a-row>
                <a-col :span="5">
                    <label class="required-icon">IP地址：</label>
                </a-col>
                <a-col :span="16">
                   <a-input  v-model="editinfo.ip" placeholder="请输入IP地址"></a-input>
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'IP黑名单',
    dataIndex: 'ip',
    key: 'ip',
  },
  {
    title: '添加时间',
    dataIndex: 'create_time',
    key: 'create_time',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
];



export default {
    data(){
        return{
            routes: [
                {path:'home/main',breadcrumbName: '首页'},
                {breadcrumbName: 'IP黑名单'},
            ],
            data:"",
            columns,
            pagination: {},
            loading: false,
            confirmLoading:false,
            editrolemodal:false,
            addrolemodal:false,
            id:"",
            ipaddress:"",
            editinfo:"",
            currentpagination:"",
            size:"small"
        
        }
    },
    mounted(){
        this.fetch()
    },
    methods:{
        // 删除
        deletip(index,event){
            var editid=event.currentTarget.id
            Modal.confirm({
                title: '提示',
                content: '您确定删除此IP吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(editid)
                },
                onCancel() {

                },
            });
        },
        handok(editid){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delipblack',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==40014){
                    this.$message.warning(res.data.msg); 
                }else if(res.data.code==200){
                    this.$message.success('删除成功');
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                }else{
                    this.$message.success(res.data.msg);
                }
            })
        },

        // 添加
        addip(){
            var params=new URLSearchParams()
            params.append('ip',this.ipaddress)
            this.$axios.post('/api/addipblack',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('添加成功'); 
                    this.addrolemodal=false
                    this.fetch();
                    
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })

        },
        addmodal(){
            this.addrolemodal=true
        },

        //编辑
        editip(){
            var params=new URLSearchParams()
            params.append('id',this.id)
            params.append('ip',this.editinfo.ip)
            this.$axios.post('/api/editipblack',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('编辑成功'); 
                    this.editrolemodal=false
                    this.fetch({
                        limits: this.currentpagination.pageSize,
                        page: this.currentpagination.current,
                    });
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            }) 
        },
        editmodal(index,event){
            var id=event.currentTarget.id
            this.id=id
            this.editrolemodal=true
            this.$axios.get("/api/getipblack",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    id:id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        handleCancel(){
            this.editrolemodal=false
            this.addrolemodal=false
        },
 

        
        handleTableChange(pagination) {
            console.log(pagination);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.currentpagination=pagination
            this.fetch({
                limits: pagination.pageSize,
                page: pagination.current,
            });
        },
        fetch(params = {}){
            this.loading = true;
            this.$axios.get("/api/ipblcakstaticlist",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    limits: 10,
                    ...params,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    this.data=res.data.data.lists
                    this.loading = false;
                    this.pagination = pagination;
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/system/ipblack.vue